import { formatDateString } from "@/v2-common/utils/utils.date"
import cn from "@/v2-ui/utils/utils.cn"
import CountryLabel from "@/v2-backoffice-client/country/CountryLabel"

export type ProjectOptionProps = {
  className?: string
  name: string
  countryCode: number | null | undefined
  createdAt: string | null | undefined
}

// One row of a project picker. Teams routinely hold several projects with
// the same name — every auto-created one is "Hovedprosjekt" — so the name
// alone gives the operator nothing to choose between. The country and the
// creation date are what tell them apart.
//
// Deliberately one line: Radix renders the chosen row's content in the
// trigger, so a stacked layout would make every closed picker two lines tall.
function ProjectOption(props: ProjectOptionProps) {
  const { className, name, countryCode, createdAt } = props

  return (
    <span className={cn("inline-flex min-w-0 items-center gap-2", className)}>
      <span className="truncate">{name}</span>
      <span className="inline-flex shrink-0 items-center gap-2 text-xs text-muted-foreground">
        <CountryLabel code={countryCode} emptyLabel="No country" />
        {createdAt && <span>{formatDateString(createdAt)}</span>}
      </span>
    </span>
  )
}

export default ProjectOption
